import type {
  ExecuteSalesMoveRequest,
  SalesActivityEvent,
  SalesMove,
  SalesMoveActionHistoryResponse,
  SalesMoveActionResult,
  SalesMoveBucket,
  SalesMovesResponse,
} from "@sales-ops-amplify/shared";
import { apiGet, apiPost } from "./client";

export type ListSalesMovesParams = {
  portfolioId?: string;
  ownerId?: string;
  bucket?: SalesMoveBucket | "ALL_ACTIVE";
  limit?: number;
  cursor?: string;
  focused?: boolean;
};

export function listSalesMoves(
  params?: ListSalesMovesParams,
): Promise<SalesMovesResponse> {
  return apiGet(
    "/api/sales-moves",
    params as Record<string, string | number | boolean | undefined>,
  );
}

export function getSalesMove(
  id: string,
  generationId?: string,
): Promise<{ move: SalesMove }> {
  return apiGet(`/api/sales-moves/${id}`, { generationId });
}

export function executeSalesMoveAction(
  id: string,
  body: ExecuteSalesMoveRequest,
  idempotencyKey?: string,
): Promise<SalesMoveActionResult> {
  return apiPost(`/api/sales-moves/${id}/actions`, body, {
    headers: idempotencyKey
      ? { "Idempotency-Key": idempotencyKey }
      : undefined,
  });
}

export function listSalesMoveActions(
  id: string,
  params?: { fingerprint?: string; limit?: number },
): Promise<SalesMoveActionHistoryResponse> {
  return apiGet(`/api/sales-moves/${id}/actions`, params);
}

export function listSalesMovesByDeals(
  dealIds: string[],
): Promise<{
  moves: Record<
    string,
    Pick<SalesMove, "id" | "headline" | "priority" | "bucket" | "recommendedAction">
  >;
}> {
  return apiGet("/api/sales-moves/by-deals", {
    dealIds: dealIds.join(","),
  });
}

export function applySalesActivityEvent(
  event: SalesActivityEvent,
): Promise<{ ok: boolean }> {
  return apiPost("/api/sales-moves/activity-events", event);
}
